

jQuery(function () {
  var present = $('#present');
  var linebanner = $('#line-banner');
  var appear = false;


  $(window).scroll(function () {
    if (window.matchMedia("(min-width: 768px)").matches) {
      if ($(window).scrollTop() > 500) {  //100pxスクロールしたら
        if (appear == false) {
          appear = true;
          present.stop().animate({
            'bottom': '210px' //下から50pxの位置に
          }, 600); //0.3秒かけて現れる         

          linebanner.stop().animate({
            'bottom': '70px' //下から50pxの位置に
          }, 600); //0.3秒かけて現れる       
        }
      } else {
        if (appear) {
          appear = false;
          present.stop().animate({
            'bottom': '-200px' //下から-200pxの位置に
          }, 600); //0.3秒かけて隠れる   

          linebanner.stop().animate({
            'bottom': '-200px' //下から-200pxの位置に
          }, 600); //0.3秒かけて隠れる   
        }
      }
    } else {
      if ($(window).scrollTop() > 500) {  //100pxスクロールしたら
        if (appear == false) {
          appear = true;
          linebanner.stop().animate({
            'bottom': '0px' //下から50pxの位置に
          }, 600); //0.3秒かけて現れる     
          present.stop().animate({
            'bottom': '0px' //下から50pxの位置に
          }, 600); //0.3秒かけて現れる      
        }

      } else {
        if (appear) {
          appear = false;
          linebanner.stop().animate({
            'bottom': '-200px' //下から-200pxの位置に
          }, 600); //0.3秒かけて隠れる   
          present.stop().animate({
            'bottom': '-200px' //下から-200pxの位置に
          }, 600); //0.3秒かけて隠れる   
        }
      }
    }
  });

$(window).resize(function() {
    var appear = false;
    if (window.matchMedia("(min-width: 768px)").matches) {
      if ($(window).scrollTop() > 500) {  //100pxスクロールしたら
        if (appear == false) {
          appear = true;
          present.stop().animate({
            'bottom': '210px' //下から50pxの位置に
          }, 600); //0.3秒かけて現れる         

          linebanner.stop().animate({
            'bottom': '70px' //下から50pxの位置に
          }, 600); //0.3秒かけて現れる       
        }
      } else {
        if (appear) {
          appear = false;
          present.stop().animate({
            'bottom': '-200px' //下から-200pxの位置に
          }, 600); //0.3秒かけて隠れる   

          linebanner.stop().animate({
            'bottom': '-200px' //下から-200pxの位置に
          }, 600); //0.3秒かけて隠れる   
        }
      }
    } else {
      if ($(window).scrollTop() > 500) {  //100pxスクロールしたら
        if (appear == false) {
          appear = true;

          linebanner.stop().animate({
            'bottom': '0px' //下から50pxの位置に
          }, 600); //0.3秒かけて現れる     
          present.stop().animate({
            'bottom': '0px' //下から50pxの位置に
          }, 600); //0.3秒かけて現れる      
        }
      } else {
        if (appear) {
          appear = false;
          linebanner.stop().animate({
            'bottom': '-200px' //下から-200pxの位置に
          }, 600); //0.3秒かけて隠れる   
          present.stop().animate({
            'bottom': '-200px' //下から-200pxの位置に
          }, 600); //0.3秒かけて隠れる   
        }
      }
    }
  });
});


jQuery(function () {
  var floatingcart = $('#floating-cart');
  var appear = false;


  $(window).scroll(function () {
    if (window.matchMedia("(min-width: 750px)").matches) {
      if ($(window).scrollTop() > 500) {  //100pxスクロールしたら
        if (appear == false) {
          appear = true;
          floatingcart.stop().animate({
            'bottom': '70px' //下から50pxの位置に
          }, 600); //0.3秒かけて現れる    
        }
      } else {
        if (appear) {
          appear = false;
          floatingcart.stop().animate({
            'bottom': '-500px' //下から-200pxの位置に
          }, 600); //0.3秒かけて隠れる   
        }
      }
    } else {
      if ($(window).scrollTop() > 500) {  //100pxスクロールしたら
        if (appear == false) {
          appear = true;
        floatingcart.stop().animate({
            'bottom':  '10.5vw' //SPバナー表示時10.5vw
          }, 600); //0.3秒かけて現れる  
        }

      } else {
        if (appear) {
          appear = false;
          floatingcart.stop().animate({
            'bottom': '-500px' //下から-200pxの位置に
          }, 600); //0.3秒かけて隠れる 
        }
      }
    }
  });

$(window).resize(function() {
    var appear = false;
    if (window.matchMedia("(min-width: 750px)").matches) {
      if ($(window).scrollTop() > 500) {  //100pxスクロールしたら
        if (appear == false) {
          appear = true;
          floatingcart.stop().animate({
            'bottom': '70px' //下から50pxの位置に
          }, 600); //0.3秒かけて現れる    
        }
      } else {
        if (appear) {
          appear = false;
          floatingcartt.stop().animate({
            'bottom': '-500px' //下から-200pxの位置に
          }, 600); //0.3秒かけて隠れる   
        }
      }
    } else {
      if ($(window).scrollTop() > 500) {  //100pxスクロールしたら
        if (appear == false) {
          appear = true;
        floatingcart.stop().animate({
            'bottom': '10.5vw' //SPバナー表示時10.5vw
          }, 600); //0.3秒かけて現れる  
        }

      } else {
        if (appear) {
          appear = false;
          floatingcart.stop().animate({
            'bottom': '-500px' //下から-200pxの位置に
          }, 600); //0.3秒かけて隠れる 
        }
      }
    }
  });
});


$(function () {
  $('.tab_list').slick({
    arrows: false,
    asNavFor: '.tab_content',//※2
    focusOnSelect: true,
    slidesToShow: 8,//※3
    infinite: false,
    speed: 400,
    cssEase: 'linear',
    useTransform: false,
    adaptiveHeight:true
  });
  $('.tab_content').slick({
    arrows: false,
    asNavFor: '.tab_list',
    adaptiveHeight:true
  });
});



$(function () {
  $('.product_list').slick({
    arrows: false,
    asNavFor: '.product_content',//※2
    slidesToShow: 5,//※3
    slidesToScroll: 1,
    swipeToSlide :true,
    focusOnSelect: true,
    vertical: true,
    verticalSwiping: true,
      responsive: [
    {
      breakpoint: 990,
      settings: {
           vertical: false,
    verticalSwiping: false,
         swipeToSlide :true,
            focusOnSelect: true,
       slidesToShow: 4, 
        slidesToScroll: 1,
      }
    }
                           ]
      });
  $('.product_content').slick({
    asNavFor: '.product_list',
        prevArrow: '<span class="tab_prev"><i class="fas fa-arrow-left"></i></span>',
        nextArrow: '<span class="tab_next"><i class="fas fa-arrow-right"></i></span>',
    swipe:false,
    
          responsive: [
    {
      breakpoint: 750,
      settings: {
    swipe:true,
      }
    }
                           ]
  });
});

/*$(function () {
  $("fieldset.product-form__input > label").click(function(){
    setTimeout(function(){
        location.reload();
    },100);
  });
});*/


     $(function () {
            $('#drip-slider').slick({
                swipeToSlide: true,
                prevArrow: '<span class="tab_prev"><i class="fas fa-chevron-left"></i></span>',
                nextArrow: '<span class="tab_next"><i class="fas fa-chevron-right"></i></span>',
                asNavFor: '#drip-text-slider',
                infinite: false,
            });

            $('#drip-text-slider').slick({
                swipeToSlide: true,
                arrows: false,
                asNavFor: '#drip-slider',
                infinite: false,
            });

            $('#drip-slider2').slick({
                swipeToSlide: true,
                prevArrow: '<span class="tab_prev"><i class="fas fa-chevron-left"></i></span>',
                nextArrow: '<span class="tab_next"><i class="fas fa-chevron-right"></i></span>',
                asNavFor: '#drip-text-slider2',
                infinite: false,
            });

            $('#drip-text-slider2').slick({
                swipeToSlide: true,
                arrows: false,
                asNavFor: '#drip-slider2',
                infinite: false,
        
            });

                   $('#tab-btn').slick({
                asNavFor: '#tab-contents',
                         arrows: false,
        focusOnSelect: true,
    slidesToShow: 3
            });

             $('#tab-contents').slick({
                swipeToSlide: true,
                arrows: false,
                asNavFor: '#tab-btn',
                infinite: false,
adaptiveHeight:true
            });

        });

